import { ChatRoom, ChatRoomType } from '@dinosband/bv-main-schema/dist/types'

export const CHAT_ROOM_ADDED = 'CHAT_ROOM_ADDED'
export const CHAT_ROOM_REMOVED = 'CHAT_ROOM_REMOVED'
export const CHAT_ROOM_UNREAD_COUNT = 'CHAT_ROOM_UNREAD_COUNT'

export interface ChatRoomAddedPayload {
  type: ChatRoomType
  channelId?: number
  chatRooms: ChatRoom[]
}